import { CoverBox } from '@/components/CoverBox';
import { LabradorComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import { withBackgroundColor } from '@/utils/withBackgroundColor';
import { convertLinkFormat } from 'base/components/CoverBox/convertLinkFormat';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { renderContentComponent } from 'modules/dynamic/components';
import { useRouter } from 'next/router';

export const LabradorCoverBox: LabradorComponent = ({ type, meta, data, descendants, ...props }) => {
  const { asPath } = useRouter();
  const { frontPagePathname } = getOcelotConfig('features.keesingGames');

  return (
    <CoverBox
      headline={data.title}
      markup={convertLinkFormat(data.bodytext)}
      images={descendants.map(renderContentComponent)}
      data-bg-color={withBackgroundColor(meta.backgroundColor)}
      data-content-index={meta.contentIndex}
      {...mergeProps({ options: { center: !!frontPagePathname && asPath.startsWith(frontPagePathname) } }, props)}
    />
  );
};
